var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mynaui:video"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.52539 15.7783V8.27832C3.52539 7.74789 3.7361 7.23918 4.11118 6.86411C4.48625 6.48903 4.99496 6.27832 5.52539 6.27832H14.0254C14.5558 6.27832 15.0645 6.48903 15.4396 6.86411C15.8147 7.23918 16.0254 7.74789 16.0254 8.27832V15.7783C16.0254 16.3088 15.8147 16.8175 15.4396 17.1925C15.0645 17.5676 14.5558 17.7783 14.0254 17.7783H5.52539C4.99496 17.7783 4.48625 17.5676 4.11118 17.1925C3.7361 16.8175 3.52539 16.3088 3.52539 15.7783ZM20.6934 7.01932L16.6934 10.5823C16.6407 10.6291 16.5985 10.6866 16.5695 10.7509C16.5405 10.8151 16.5255 10.8848 16.5254 10.9553V12.7333C16.5255 12.8038 16.5405 12.8735 16.5695 12.9378C16.5985 13.0021 16.6407 13.0595 16.6934 13.1063L20.6934 16.6693C20.7655 16.7333 20.8545 16.7751 20.9498 16.7897C21.045 16.8043 21.1425 16.791 21.2304 16.7515C21.3183 16.712 21.3929 16.6479 21.4452 16.567C21.4976 16.486 21.5254 16.3917 21.5254 16.2953V7.39332C21.5254 7.29694 21.4976 7.20261 21.4452 7.12167C21.3929 7.04074 21.3183 6.97666 21.2304 6.93714C21.1425 6.89763 21.045 6.88436 20.9498 6.89894C20.8545 6.91352 20.7655 6.95532 20.6934 7.01932Z",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.24d260e218fed7f834bc256dbba66aca.svg";
export { ForwardRef as ReactComponent };